module.exports = __webpack_public_path__ + "img/code.bbef26ce.png";